export const H1 = ({ children }: { children: string }) => {
  return <div className="text-21px font-semibold mb-2">{children}</div>;
};

export const H2 = ({ children }: { children: string }) => {
  return <div className="text-17px font-semibold mb-2">{children}</div>;
};

export const H3 = ({ children }: { children: string }) => {
  return <div className="text-15px font-semibold mb-2">{children}</div>;
};

export const H4 = ({ children }: { children: string }) => {
  return <div className="text-14px font-semibold mb-2">{children}</div>;
};

export const H5 = ({ children }: { children: string }) => {
  return <div className="text-xs font-semibold mb-2">{children}</div>;
};
